import { Tooltip } from '@bugbug/core/components/Tooltip/RefactoredTooltip';

import type { PlanFeature as PlanFeatureType } from '../Subscription/Subscription.constants';

import { HelperIcon } from '../SubscriptionList/SubscriptionList.styled';

import * as S from './PlanFeature.styled';

export const PlanFeature = ({ tooltip, icon, label }: PlanFeatureType) => (
  <Tooltip fitContent content={tooltip}>
    <S.FeatureContainer>
      {icon ?? <S.FeatureIcon name="check" />}
      <S.FeatureLabel>
        {label} {tooltip ? <HelperIcon /> : null}
      </S.FeatureLabel>
    </S.FeatureContainer>
  </Tooltip>
);
